<template>
  <Modal
    :is-open="showModal"
    size="md"
    data-testid="modal-performance-details"
    @close="$emit('close')"
  >
    <HeadingDisplay
      :title="details?.label"
      size="small"
      :color="NebraskaColors.elementPrimary"
    />
    <Row
      v-for="(item, index) in rows"
      :key="index"
      class="row"
      :has-line="index > 0"
    >
      <template #top-left>
        <BaseText size="md" as="p" :color="NebraskaColors.elementPrimary">
          {{ item.leftTitle }}
        </BaseText>
      </template>
      <template v-if="item.leftSubtitle" #bottom-left>
        <BaseText
          size="sm"
          as="p"
          :color="
            item?.colorLeftSubtitle
              ? item?.colorLeftSubtitle
              : NebraskaColors.elementSecondary
          "
        >
          <Money>
            {{ item.leftSubtitle }}
          </Money>
        </BaseText>
      </template>
      <template #top-right>
        <BaseText size="md" as="p" :color="NebraskaColors.elementPrimary">
          <Money>
            {{ item.rightTitle }}
          </Money>
        </BaseText>
      </template>
    </Row>
  </Modal>
</template>
<script lang="ts" setup>
import { IMonthly } from '@/modules/investments/types/Performance';
import { computed } from 'vue';
import { Money } from '@/modules/common/components/Money';
import {
  Modal,
  HeadingDisplay,
  Row,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
interface Props {
  details: IMonthly | null;
  benchmarkSelected: string;
  benchmarkComparisonSelected: string;
  showModal: boolean;
}

const props = defineProps<Props>();

interface Emits {
  (event: 'close'): void;
}

defineEmits<Emits>();

const rows = computed(() => {
  const lines = [
    {
      leftTitle: 'Rendimento bruto',
      rightTitle: props.details?.values?.profitValues?.formatted,
      leftSubtitle: 'Inclui proventos e cashback'
    },
    {
      leftTitle: 'Rentabilidade bruta',
      rightTitle: props.details?.values?.returns?.formatted,
      leftSubtitle: getBenchmarkComparisonValue(
        props.details?.values?.benchmarkComparison?.formatted
      ),
      colorLeftSubtitle: !props.details?.values?.benchmarkComparison?.isNegative
        ? NebraskaColors.monetaryPositive
        : NebraskaColors.monetaryNegative
    }
  ];
  if (props.benchmarkSelected && props.details?.values?.benchmark?.formatted) {
    lines.push({
      leftTitle: props.benchmarkSelected,
      rightTitle: props.details?.values?.benchmark?.formatted
    });
  }
  return lines;
});

const getBenchmarkComparisonValue = (value: string) => {
  if (!props?.benchmarkSelected) return '';
  return props?.benchmarkSelected === 'CDI'
    ? `${value} do CDI`
    : `${props?.benchmarkComparisonSelected} ${value}`;
};
</script>
<style lang="less" scoped>
:deep(.modal-content) {
  align-items: baseline;
  padding: 0 @size-spacing-x1000 @size-spacing-x600;
}

:deep(.row) {
  .wrapper {
    align-items: center;
  }
}
.row {
  width: 100%;
  padding: 0;
}
</style>
